const LABELS: Record<string, string> = {
  ristoranti: 'Ristoranti',
  pizzerie: 'Pizzerie e asporto',
  asporto: 'Asporto',
  fastfood: 'Fast food',
  bar: 'Bar e caffè',
  cafe: 'Bar e caffè',
  gelaterie: 'Gelaterie',
  panifici: 'Panifici e pasticcerie',
  bakery: 'Panifici e pasticcerie',
  macellerie: 'Macellerie',
  supermercati: 'Supermercati',
  minimarket: 'Minimarket',
  tabacchi: 'Tabaccherie',
  enoteche: 'Enoteche',
  pub: 'Pub e locali serali',
  parrucchieri: 'Parrucchieri e barbieri',
  estetica: 'Estetica e benessere',
  farmacie: 'Farmacie',
  dentisti: 'Studi dentistici',
  veterinari: 'Veterinari',
  palestre: 'Palestre e fitness',
  fitness: 'Palestre e fitness',
  sport: 'Centri sportivi',
  ferramenta: 'Ferramenta e casalinghi',
  lavanderie: 'Lavanderie',
  officine: 'Officine e gommisti',
  immobiliari: 'Agenzie immobiliari',
  fiorai: 'Fiorai',
  abbigliamento: 'Abbigliamento e scarpe',
  librerie: 'Librerie e cartolerie',
  gioiellerie: 'Gioiellerie',
  petshop: 'Negozi per animali',
  elettronica: 'Elettronica e telefonia',
};

const FOOD = new Set(['ristoranti', 'pizzerie', 'asporto', 'fastfood', 'bar', 'cafe', 'gelaterie', 'panifici', 'bakery', 'macellerie', 'supermercati', 'minimarket', 'tabacchi', 'enoteche', 'pub']);
const RETAIL = new Set(['ferramenta', 'fiorai', 'abbigliamento', 'librerie', 'gioiellerie', 'petshop', 'elettronica', 'supermercati', 'minimarket', 'tabacchi', 'macellerie', 'enoteche']);

export type ZoneMacroGroup = 'ristorazione' | 'retail' | 'servizi';

export function zoneCategoryLabel(key: string | null | undefined): string {
  if (!key) return 'Categoria non disponibile';
  return LABELS[key] ?? key.replaceAll('_', ' ').replaceAll('-', ' ');
}

export function zoneCategoryGroup(key: string | null | undefined): ZoneMacroGroup {
  if (key && FOOD.has(key)) return 'ristorazione';
  if (key && RETAIL.has(key)) return 'retail';
  return 'servizi';
}
